module.exports = __webpack_public_path__ + "static/media/map-current.ce737517.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/map-current.jpg
// module id = 653
// module chunks = 0